import { render, staticRenderFns } from "./InfoPagination.vue?vue&type=template&id=7fc826a2&scoped=true"
import script from "./InfoPagination.vue?vue&type=script&lang=js"
export * from "./InfoPagination.vue?vue&type=script&lang=js"
import style0 from "./InfoPagination.vue?vue&type=style&index=0&id=7fc826a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc826a2",
  null
  
)

export default component.exports